import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AddressAutocomplete from './AddressAutocomplete';
import './MerchantAdmin.css';

function Apply() {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        address: '',
        country: '',
        cityId: '',
        address_text: ''
    });
    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    // 获取国家列表（从 cities 表中提取不重复的国家）
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const res = await axios.get('/api/cities');
                const uniqueCountries = [...new Map(res.data.map(city => [city.country, city.country])).values()];
                setCountries(uniqueCountries.map(country => ({ name: country })));
            } catch (err) {
                console.error('获取国家列表失败', err);
            }
        };
        fetchCountries();
    }, []);

    // 根据选中的国家加载城市列表
    useEffect(() => {
        if (formData.country) {
            const fetchCitiesByCountry = async () => {
                try {
                    const res = await axios.get('/api/cities');
                    const filtered = res.data.filter(city => city.country === formData.country);
                    setCities(filtered);
                } catch (err) {
                    console.error('获取城市列表失败', err);
                }
            };
            fetchCitiesByCountry();
        } else {
            setCities([]);
        }
    }, [formData.country]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAddressChange = (val) => {
        setFormData(prev => ({ ...prev, address_text: val }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name || !formData.country || !formData.cityId || !formData.address_text) {
            setMessage('请填写所有必填项');
            return;
        }
        setLoading(true);
        const tg = window.Telegram.WebApp;
        try {
            const payload = {
                ownerId: tg.initDataUnsafe?.user?.id,
                name: formData.name,
                description: formData.description,
                address: formData.address,
                cityId: formData.cityId,
                address_text: formData.address_text,
                latitude: null,
                longitude: null
            };
            const res = await axios.post('/api/merchant/apply', payload, {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            setMessage('申请已提交，请等待审核');
            setFormData({
                name: '', description: '', address: '', country: '', cityId: '', address_text: ''
            });
        } catch (err) {
            setMessage(err.response?.data?.error || '提交失败，请稍后重试');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="merchant-admin-card" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h2>商家入驻申请</h2>
            <form onSubmit={handleSubmit} className="merchant-admin-form">
                <div className="merchant-admin-form-group">
                    <label>店铺名称 <span style={{ color: 'red' }}>*</span></label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="请输入店铺名称"
                    />
                </div>

                <div className="merchant-admin-form-group">
                    <label>店铺描述</label>
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        rows="3"
                        placeholder="介绍您的店铺特色、营业时间等"
                    />
                </div>

                <div className="merchant-admin-form-group">
                    <label>显示地址（可选）</label>
                    <input
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="例如：武吉免登路88号"
                    />
                    <small>该地址将展示给顾客，可简写</small>
                </div>

                <div className="merchant-admin-form-group">
                    <label>国家 <span style={{ color: 'red' }}>*</span></label>
                    <select
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        required
                    >
                        <option value="">请选择国家</option>
                        {countries.map((c, idx) => (
                            <option key={idx} value={c.name}>{c.name}</option>
                        ))}
                    </select>
                </div>

                <div className="merchant-admin-form-group">
                    <label>城市 <span style={{ color: 'red' }}>*</span></label>
                    <select
                        name="cityId"
                        value={formData.cityId}
                        onChange={handleChange}
                        required
                        disabled={!formData.country}
                    >
                        <option value="">请选择城市</option>
                        {cities.map(city => (
                            <option key={city.id} value={city.id}>{city.city_name}</option>
                        ))}
                    </select>
                </div>

                <div className="merchant-admin-form-group">
                    <label>详细地址 <span style={{ color: 'red' }}>*</span></label>
                    <AddressAutocomplete
                        value={formData.address_text}
                        onChange={handleAddressChange}
                        placeholder="例如：吉隆坡武吉免登路88号"
                        className="address-input"
                    />
                    <small>请填写详细的门牌号、街道等</small>
                </div>

                {message && (
                    <div className="form-message" style={{ marginTop: '16px' }}>
                        {message}
                    </div>
                )}

                <button type="submit" className="merchant-admin-btn" disabled={loading}>
                    {loading ? '提交中...' : '提交申请'}
                </button>
            </form>
        </div>
    );
}

export default Apply;